import { useState } from 'react';
import {
  CATEGORIES,
  CATEGORY_META,
  PRIORITIES,
  type Category,
  type ListItem,
  type Priority,
} from '@travel-planner/shared';
import { useDeleteItem, useUpdateItem } from '../lists/useListItems';

// Details/edit panel for a selected marker (which is a list item).
export function MarkerPanel({
  tripId,
  item,
  onClose,
}: {
  tripId: string;
  item: ListItem;
  onClose: () => void;
}) {
  const update = useUpdateItem(tripId, item.countryId);
  const del = useDeleteItem(tripId, item.countryId);
  const [title, setTitle] = useState(item.title);
  const [category, setCategory] = useState<Category>(item.category);
  const [priority, setPriority] = useState<Priority>(item.priority);

  const dirty = title !== item.title || category !== item.category || priority !== item.priority;

  return (
    <div className="glass d-flex flex-column gap-2 p-3 rounded-3" style={{ width: 280 }}>
      <div className="d-flex justify-content-between align-items-center">
        <strong>Marker</strong>
        <button className="btn btn-ghost btn-sm p-1" onClick={onClose} title="Close" style={{ minHeight: 'auto' }}>
          ✕
        </button>
      </div>
      <label className="d-flex flex-column gap-1 small">
        Title
        <input className="form-control form-control-sm" value={title} onChange={(e) => setTitle(e.target.value)} />
      </label>
      <div className="d-flex gap-2">
        <label className="d-flex flex-column gap-1 small flex-grow-1">
          Category
          <select className="form-select form-select-sm" value={category} onChange={(e) => setCategory(e.target.value as Category)}>
            {CATEGORIES.map((c) => (
              <option key={c} value={c}>
                {CATEGORY_META[c].icon} {CATEGORY_META[c].label}
              </option>
            ))}
          </select>
        </label>
        <label className="d-flex flex-column gap-1 small flex-grow-1">
          Priority
          <select className="form-select form-select-sm" value={priority} onChange={(e) => setPriority(e.target.value as Priority)}>
            {PRIORITIES.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className="text-body-tertiary" style={{ fontSize: '0.72rem' }}>
        {item.lat?.toFixed(4)}, {item.lng?.toFixed(4)}
      </div>
      <div className="d-flex gap-2 flex-wrap">
        <button
          className="btn btn-primary btn-sm"
          disabled={!dirty || update.isPending}
          onClick={() => update.mutate({ itemId: item.id, patch: { title: title.trim(), category, priority } })}
        >
          {update.isPending ? 'Saving…' : 'Save'}
        </button>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => update.mutate({ itemId: item.id, patch: { lat: null, lng: null } }, { onSuccess: onClose })}
          title="Keep the list item but remove its map location"
        >
          Remove from map
        </button>
        <button
          className="btn btn-ghost btn-sm text-danger"
          onClick={() => {
            if (confirm(`Delete "${item.title}" entirely?`)) del.mutate(item.id, { onSuccess: onClose });
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
}
